module.exports = __webpack_public_path__ + "static/media/visibility-24px.a7ef89e8.svg";